module.exports = __webpack_public_path__ + "img/wzf_9.40f72e45.png";